import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase/app';


@Injectable({
  providedIn: 'root'
})


export class ErrorHandlerService implements ErrorHandler {

  constructor( 
    private _AngularFireAuth: AngularFireAuth
    ) { }

  handleError(error: HttpErrorResponse) {
    
    if (error.error instanceof ErrorEvent) {
      console.log('Client Side Error', error.error.message);
    } else {
      console.log( 'Server Side Error', error.status, error.message);
    }
    return throwError("there is somthing went wrong");
    
  }


}
